import { gtmTrackEvent, gtmTrackEventError } from './gtmTrackEvent';
import { ItemDataLayer } from './mapper/LineItemMapper';

export const gtmApplyPromoCode = (code: string) => {
  const eventKey = 'apply_promo_code';
  try {
    const eventObject = {
      interaction: {
        promo_code: code,
      },
    };

    gtmTrackEvent(eventKey, eventObject);
  } catch (error: any) {
    gtmTrackEventError(error, eventKey);
  }
};

export const gtmAddToRegistry = ({ itemDataLayer, quantity }: { itemDataLayer: ItemDataLayer; quantity: number }) => {
  const eventKey = 'add_to_registry';

  try {
    const eventObject = {
      interaction: {
        item_id: itemDataLayer.item_id,
        item_name: itemDataLayer.item_name,
        currency: 'USD',
        quantity,
        price: itemDataLayer.price,
        value: parseFloat((quantity * itemDataLayer.price!).toFixed(2)),
      },
    };

    gtmTrackEvent(eventKey, eventObject);
  } catch (error: any) {
    gtmTrackEventError(error, eventKey);
  }
};

export const gtmImageScroll = ({
  click_action,
  item_id,
  media_name,
}: {
  click_action: 'view images' | 'watch video';
  item_id: string;
  media_name: string;
}) => {
  const eventKey = 'image_scroll';

  try {
    const eventObject = {
      interaction: {
        click_action,
        item_id,
        media_name,
      },
    };

    gtmTrackEvent(eventKey, eventObject);
  } catch (error: any) {
    gtmTrackEventError(error, eventKey);
  }
};

export const gtmAccordionInteraction = ({
  click_action,
  interaction_location,
  interaction_text,
}: {
  click_action: 'Expand' | 'Collapse';
  interaction_text: string;
  interaction_location: string;
}) => {
  const eventKey = 'accordion_interaction';

  try {
    const eventObject = {
      interaction: {
        click_action,
        interaction_location,
        interaction_text,
      },
    };

    gtmTrackEvent(eventKey, eventObject);
  } catch (error: any) {
    gtmTrackEventError(error, eventKey);
  }
};

export const gtmMenuNavigation = ({ click_location, click_name }: { click_name: string; click_location: string }) => {
  const eventKey = 'menu_navigation';

  try {
    const eventOjbect = {
      interaction: {
        click_location,
        click_name,
      },
    };

    gtmTrackEvent(eventKey, eventOjbect);
  } catch (error: any) {
    gtmTrackEventError(error, eventKey);
  }
};

export const gtmBreadcrumbClick = (text: string) => {
  const eventKey = 'breadcrumb_click';

  try {
    const eventObject = {
      interaction: {
        click_name: text,
      },
    };

    gtmTrackEvent(eventKey, eventObject);
  } catch (error: any) {
    gtmTrackEventError(error, eventKey);
  }
};

export const gtmFormStartInteraction = (formName: string) => {
  const eventKey = 'form_start';

  try {
    const eventObject = {
      form_name: formName,
    };

    gtmTrackEvent(eventKey, eventObject);
  } catch (error: any) {
    gtmTrackEventError(error, eventKey);
  }
};

export const gtmFormSubmit = ({
  catalogueFormat,
  formName,
  hashedEmail,
  newsletterOptIn,
  referralSource,
  region,
  country,
  typeOfRegistry,
}: {
  formName: string;
  hashedEmail?: string;
  region?: string;
  referralSource?: string;
  country?: string;
  typeOfRegistry?: string;
  catalogueFormat?: string;
  newsletterOptIn?: boolean;
}) => {
  const eventKey = 'form_submit';
  try {
    const eventObject = {
      interaction: {
        form_name: formName,
        hashed_email: hashedEmail,
        region,
        referral_source: referralSource,
        country,
        type_of_registry: typeOfRegistry,
        catalogue_format: catalogueFormat,
        newsletter_opt_in: newsletterOptIn,
      },
    };

    gtmTrackEvent(eventKey, eventObject);
  } catch (error: any) {
    gtmTrackEventError(error, eventKey);
  }
};

export const gtmFormError = ({
  errorField,
  errorMessage,
  formName,
}: {
  formName: string;
  errorField: string;
  errorMessage: string;
}) => {
  const eventKey = 'form_error';
  try {
    const eventObject = {
      interaction: {
        form_name: formName,
        error_field: errorField,
        error_message: errorMessage,
      },
    };
    gtmTrackEvent(eventKey, eventObject);
  } catch (error: any) {
    gtmTrackEventError(error, eventKey);
  }
};
export const gtmClickCta = ({ location, name }: { name: string; location: string }) => {
  const eventKey = 'click_cta';
  try {
    const eventObject = {
      interaction: {
        click_name: name,
        click_location: location,
      },
    };
    gtmTrackEvent(eventKey, eventObject);
  } catch (error: any) {
    gtmTrackEventError(error, eventKey);
  }
};
